import mapActions from "actions/map";
import modalActions from "actions/modal";
import profileActions from "actions/profile";
import { OrganizationProfileModel, TileType } from "api";
import LeafletMap from "components/map";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Action, ActionFunctionAny } from "redux-actions";

const mapStateToProps = (state: {
    map: {
        mode: "main" | "picker";
        viewport: [number, number];
        data: {};
        params: {};
        header: {};
        platonPoints: [];
        postamatPoints: [];
        paymentPoints: [];
        roadRestrictions: [];
        roadRestrictionTypes: [];
        regionDryingPeriods: [];
    };
    layout: { fullscreen: boolean };
    configs: { tileUrls: { title: string; type: TileType; url: string; options: { subdomains?: string | string[] } } };
    profile: {
        roles: [];
        profile: { canCreateBids: boolean };
        organization: OrganizationProfileModel;
        timezone: string;
    };
    dictionaries: {
        enums: { [key: string]: { label: string; value: number; options: { id: number; value: [] }[] }[] };
    };
}) => ({
    mode: state.map.mode,
    viewport: state.map.viewport,
    data: state.map.data,
    fullscreen: state.layout.fullscreen,
    tileUrls: state.configs.tileUrls,
    params: state.map.params,
    organizationTimezone: state.profile.timezone,
    organization: state.profile.organization,
    roles: state.profile.roles,
    enums: state.dictionaries.enums,
    profile: state.profile.profile,
    header: state.map.header,
    platonPoints: state.map.platonPoints,
    postamatPoints: state.map.postamatPoints,
    paymentPoints: state.map.paymentPoints,
    roadRestrictions: state.map.roadRestrictions,
    roadRestrictionTypes: state.map.roadRestrictionTypes,
    regionDryingPeriods: state.map.regionDryingPeriods,
});

const mapDispatchToProps = (dispatch: ActionFunctionAny<Action<Object>>) => ({
    switchMap: (params: {}) => dispatch(mapActions.switchMap(params)),
    mergeMapViewport: (params: {}) => dispatch(mapActions.mergeMapViewport(params)),
    mergeMapData: (params: {}) => dispatch(mapActions.mergeMapData(params)),
    changeCenter: (params: {}) => dispatch(mapActions.changeCenter(params)),
    mergeParams: (params: {}) => dispatch(mapActions.mergeParams(params)),
    modal: (params: {}) => dispatch(modalActions.open(params)),
    addModal: (params: {}) => dispatch(modalActions.add(params)),
    getOrg: () => dispatch(profileActions.getOrg()),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LeafletMap));
